import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;

    background: rgba(255, 255, 255, 0.45);

    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
`;

const ProcessingCard = styled.div`
    width: 380px;
    padding: 35px 30px;

    background: #ffffff;
    border-radius: 14px;

    text-align: center;

    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
`;

const Spinner = styled.div`
    width: 48px;
    height: 48px;

    margin: 0 auto;

    border: 4px solid #e9ecef;
    border-top: 4px solid #00adf0;

    border-radius: 50%;

    animation: ${spin} 0.8s linear infinite;
`;

const Title = styled.h4`
    margin-top: 20px;
    margin-bottom: 10px;

    font-weight: 600;
    color: #212529;
`;

const Message = styled.p`
    margin: 0;

    color: #6c757d;
    line-height: 1.6;
`;

const StaxPaymentProcessing = () => {
    return (
        <Overlay>
            <ProcessingCard>
                <Spinner />

                <Title>Processing Payment</Title>

                <Message>
                    Your payment is being processed securely.
                    <br />
                    Please don't close or refresh this window.
                </Message>
            </ProcessingCard>
        </Overlay>
    );
};

export default StaxPaymentProcessing;